import { ActionContext, ActionTree } from "vuex";
import { StatusCodes } from "http-status-codes";
import OrganizationPromosAndDeals from "@/modules/Deals/services/deals.service";
import { NOTIFICATION_TYPES } from "@/core/enums/NOTIFICATION_TYPES";
import notificationService from "@/core/services/notification.service";
import { IDealsState } from "@/modules/Deals/vuex/state";
import { StoreState } from "@/store/type";

const actions: ActionTree<IDealsState, StoreState> = {
  // ****** Fetch Deals And Promos ******
  async getOrganizationPromosAndDeals(
    context: ActionContext<IDealsState, StoreState>,
    params: string,
  ) {
    try {
      context.commit("isPromoAndDealFetching", true);

      const organizationPromosAndDeals = new OrganizationPromosAndDeals();
      const response =
        await organizationPromosAndDeals.getOrganizationPromos(params);

      if (
        response.success &&
        response.status === StatusCodes.OK &&
        response.data?.data
      ) {
        context.commit("fetchedOrganizationPromosAndDeals", response.data.data);
      } else {
        throw response;
      }
    } catch (error: any) {
      notificationService.type = NOTIFICATION_TYPES.ERROR;
      notificationService.description = error?.message || "";
      notificationService.triggerNotification();
    } finally {
      context.commit("isPromoAndDealFetching", false);
    }
  },
};

export default actions;
